import * as React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import get from 'lodash/get';
import { fetchModalPageData } from 'actions/V4Actions/v4ActionModal';
import styles from './PartPriceKnowMore.css';
import { ModalTypes, V4ModalChunkName } from 'constants/pageTypes';
import { CallBackType } from 'pages/MultiWidgetPage/MultiwidgetBase/MultiwidgetTypes/MultiWidgetCallBackProps';
const modalSettings = {
    classNames: {
        dialog: styles['pre-book-modal'],
        overlay: styles['prebook-modal-overlay-class']
    }
};
export class PartPriceKnowMore extends React.Component {
    constructor() {
        super(...arguments);
        this.handleKnowMoreClick = () => {
            const knowMoreUrl = get(this.props, ['data', 'action', 'url']);
            if (!knowMoreUrl) {
                return;
            }
            const { handleCallBack, fetchModalPageData, isV4Context = true } = this.props;
            if (handleCallBack && isV4Context) {
                handleCallBack({
                    type: CallBackType.LOAD_MODAL,
                    modalSettings,
                    pageUri: knowMoreUrl,
                    chunkName: V4ModalChunkName.PRE_ORDER_MODAL,
                    loadingClass: styles['modal-loading-class'],
                    errorClass: styles['modal-loading-error']
                });
            }
            else {
                fetchModalPageData(knowMoreUrl, undefined, {
                    modalOptions: {
                        modalSettings,
                        type: ModalTypes.NORMAL_VIEW
                    }
                });
            }
            this.props.onKnowMoreAction && this.props.onKnowMoreAction();
        };
    }
    render() {
        const knowMoreUrl = get(this.props, ['data', 'action', 'url'], '');
        const knowMoreText = get(this.props, ['data', 'value', 'title'], '');
        const { className } = this.props;
        if (!knowMoreUrl || !knowMoreText) {
            return null;
        }
        return (<div className={cx(styles['know-more'], className)} onClick={this.handleKnowMoreClick}>
				{knowMoreText}
			</div>);
    }
}
const mapDispatchToProps = {
    fetchModalPageData
};
export default connect(null, mapDispatchToProps)(PartPriceKnowMore);
